import "../scss/style.scss";
import "./anime.js"
import "./splide-extension-auto-scroll.js"
import "./splide_setting.js"
import "./index.js"
